import React, { useEffect, useRef, useState } from 'react';
import { Container } from './Dashboard.styles';
import KpiList from './KpiList/KpiList';
import TableView from './TableView';
import {
	Breadcrumbs,
	ContentWrapper,
	DateRangeWrapper,
	FilterWrapper,
} from './CategoryDashboard.styles';
import {
	filterSelectedOptions,
	transformFilterOptions,
} from '../MultisourceSkuData/MultisourceSkuData';
import MultiSelect from '../MultisourceSkuData/components/MultiSelect';
import {
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import {
	getDatesSKU,
	getDistinctSku,
	getModuleFilter,
} from 'utils/apiRequests';
import { isNull } from 'lodash';
import {
	getDateFormat,
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
} from 'CategoryManagement/utils';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';

const filterInitialOptions = {
	category_1: {
		options: [],
		selectedOption: [],
	},
	category_2: {
		options: [],
		selectedOption: [],
	},
	category_3: {
		options: [],
		selectedOption: [],
	},
	commodity_Code: {
		options: [],
		selectedOption: [],
	},
	commodity_Family: {
		options: [],
		selectedOption: [],
	},
	supplier_count: {
		options: [],
		selectedOption: [],
	},
	origin_Country: {
		options: [],
		selectedOption: [],
	},
	dateRange: {
		srcRange: '',
		stateRange: '',
	},
};
function createLabelValueArray() {
	const array = [];
	for (let i = 1; i <= 10; i++) {
		array.push({
			label: `> ${i}`,
			value: i,
		});
	}
	return array;
}
const CategoryDashboard = ({ modelId, setContent, currencySymbol }) => {
	const [filterData, setFilterData] = useState(filterInitialOptions);
	const [distinctSku, setDistinctSku] = useState([]);
	const [isFilterLoading, setIsFilterLoading] = useState(true);
	const [skuCteFilterModel, setSkuCteFilterModel] = useState({});
	const [isRenderingInitially, setIsRenderingInitially] = useState(1);
	const gridRef = useRef();

	const checkAndFormat = data => {
		return data.filter(x => x !== null).map(x => {
			return { label: x, value: x };
		});
	};

	useEffect(() => {
		const supplierCountOptions = createLabelValueArray();
		const payload = {
			modelId: modelId,
		};
		try {
			Promise.all([getModuleFilter(payload), getDatesSKU()]).then(
				([filterResponse, dateResponse]) => {
					if (filterResponse.succeeded && dateResponse.succeeded) {
						if (!isNull(filterResponse.data)) {
							if (Object.keys(filterResponse.data).length > 0) {
								const formatedCategory1Options = checkAndFormat(
									filterResponse.data.category1
								);
								const formatedCategory2Options = checkAndFormat(
									filterResponse.data.category2
								);
								const formatedCategory3Options = checkAndFormat(
									filterResponse.data.category3
								);
								const formatedCommodityCodeOptions = checkAndFormat(
									filterResponse.data.commodityCode
								);
								const formatedcommodityFamilyOptions = checkAndFormat(
									filterResponse.data.commodityFamily
								);
								const formatedCountryOriginOptions = checkAndFormat(
									filterResponse.data.originCountry
								);
								const minDate = dateResponse?.data?.minDate.split('T')[0];
								const maxDate = dateResponse?.data?.maxDate.split('T')[0];
								const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
								const selectedRange = getDateRangeMonthYearState(
									minDate,
									maxDate
								);
								const filterDataToSet = {
									category_1: {
										options: formatedCategory1Options,
										selectedOption: [
											formatedCategory1Options.map(x => x?.value)[0],
										],
									},
									category_2: {
										options: formatedCategory2Options,
										selectedOption: [],
									},
									category_3: {
										options: formatedCategory3Options,
										selectedOption: [],
									},
									commodity_Code: {
										options: formatedCommodityCodeOptions,
										selectedOption: [],
									},
									commodity_Family: {
										options: formatedcommodityFamilyOptions,
										selectedOption: [],
									},
									supplier_count: {
										options: supplierCountOptions,
										selectedOption: [1],
									},
									origin_Country: {
										options: formatedCountryOriginOptions,
										selectedOption: [],
									},
									dateRange: {
										srcRange: wholeRange,
										stateRange: selectedRange,
									},
								};
								setFilterData(prevState => ({
									...prevState,
									...filterDataToSet,
								}));
								const { dateFrom, dateTo } = getDateFormat(
									filterDataToSet.dateRange.stateRange
								);
								const distinctSKUpayload = {
									filtersDto: {
										category1: filterDataToSet.category_1.selectedOption,
										category2: filterDataToSet.category_2.selectedOption,
										category3: filterDataToSet.category_3.selectedOption,
										commodityCode:
											filterDataToSet.commodity_Code.selectedOption,
										commodityFamily:
											filterDataToSet.commodity_Family.selectedOption,
										originCountry:
											filterDataToSet.origin_Country.selectedOption,
									},
									modelId: modelId,
									startDate: dateFrom,
									endDate: dateTo,
									supplierCount: Math.max(
										...filterDataToSet.supplier_count.selectedOption
									),
								};
								getDistinctSku(distinctSKUpayload).then(response =>
									setDistinctSku(response.data.sku)
								);
								setIsFilterLoading(false);

								const mergedFiltersData = transformForSkuCteFilterModel(
									filterDataToSet
								);
								setSkuCteFilterModel(mergedFiltersData);
							}
						}
					}
				}
			);
		} catch (error) {
			console.log(error);
			setIsFilterLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onFilterChangeHandler = (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
	};

	const onFilterApplyHandler = () => {
		const mergedFiltersData = transformForSkuCteFilterModel(filterData);
		setSkuCteFilterModel(mergedFiltersData);
		if (isRenderingInitially) {
			setIsRenderingInitially(isRenderingInitially + 1);
		}
	};

	const transformForSkuCteFilterModel = filterData => {
		const filtersApplied = filterSelectedOptions(filterData);
		const filterModelData = transformFilterOptions(filtersApplied);
		// const mergedFiltersData = mergeFilters(filterModelData, filtersForTable);
		return filterModelData;
	};

	const Loading = () => <ApLoaderDefault loaderText={() => <ApLoaderText />} />;

	return (
		<ContentWrapper>
			{false ? (
				<div style={{ marginTop: '150px' }}>
					<Loading />
				</div>
			) : (
				<>
					<Breadcrumbs>
						<span onClick={() => setContent(0)}>Segmented Data</span>&nbsp;/&nbsp;<span
						>
							Dashboard
						</span>
					</Breadcrumbs>
					{isFilterLoading ? (
						<Loading />
					) : (
						<FilterWrapper>
							<MultiSelect
								name="category_1"
								label="Category 1"
								options={filterData.category_1.options}
								selected={filterData.category_1.selectedOption}
								isLoading={isFilterLoading}
								onChange={v => {
									onFilterChangeHandler('category_1', v);
								}}
							/>

							<MultiSelect
								name="category_2"
								label="Category 2"
								options={filterData.category_2.options}
								selected={filterData.category_2.selectedOption}
								isLoading={false}
								onChange={v => {
									onFilterChangeHandler('category_2', v);
								}}
							/>
							<MultiSelect
								name="category_3"
								label="Category 3"
								options={filterData.category_3.options}
								selected={filterData.category_3.selectedOption}
								isLoading={false}
								onChange={v => {
									onFilterChangeHandler('category_3', v);
								}}
							/>
							<MultiSelect
								name="commodity_code"
								label="Commodity Code"
								options={filterData.commodity_Code.options}
								selected={filterData.commodity_Code.selectedOption}
								isLoading={false}
								onChange={v => {
									onFilterChangeHandler('commodity_Code', v);
								}}
							/>
							<MultiSelect
								name="commodity_family"
								label="Commodity Family"
								options={filterData.commodity_Family.options}
								selected={filterData.commodity_Family.selectedOption}
								isLoading={false}
								onChange={v => {
									onFilterChangeHandler('commodity_Family', v);
								}}
							/>
							<MultiSelect
								name="supplier_count"
								label="Supplier Threshold"
								options={filterData.supplier_count.options}
								selected={filterData.supplier_count.selectedOption}
								onChange={v => {
									onFilterChangeHandler('supplier_count', v);
								}}
							/>
							<MultiSelect
								name="origin_Country"
								label="Origin Country"
								options={filterData.origin_Country.options}
								selected={filterData.origin_Country.selectedOption}
								onChange={v => {
									onFilterChangeHandler('origin_Country', v);
								}}
							/>
							<DateRangeWrapper>
								<MonthPicker
									srcRange={filterData.dateRange.srcRange}
									stateRange={filterData.dateRange.stateRange}
									onConfirm={e => {
										setFilterData(prevState => ({
											...prevState,
											dateRange: {
												...prevState.dateRange,
												stateRange: e,
											},
										}));
									}}
								/>
							</DateRangeWrapper>
							<ApButtonMain onClick={onFilterApplyHandler} small>
								Apply Filters
							</ApButtonMain>
						</FilterWrapper>
					)}

					<Container>
						{!isFilterLoading && (
							<KpiList
								modelId={modelId}
								filterData={filterData}
								counterToTriggerKPI={isRenderingInitially}
								currencySymbol={currencySymbol}
							/>
						)}
					</Container>

					{!isFilterLoading &&
						Object.keys(skuCteFilterModel).length !== 0 && (
							<TableView
								gridRef={gridRef}
								content={modelId}
								filterData={filterData}
								skuCteFilterModel={skuCteFilterModel}
								isRenderingInitially={isRenderingInitially}
								currencySymbol={currencySymbol}
								distinctSku={distinctSku}
							/>
						)}
				</>
			)}
		</ContentWrapper>
	);
};

export default CategoryDashboard;
